{
  "n/a": "N/D",
  "authorization_in_progress": "Autorizando ...",
  "will_redirect_to": "Le redirigiremos a",
  "login": {
    "identifying_organization": "Identificando su organización..."
  },
  "go_back": "Volver",
  "pairing": {
    "title": "Conectar dispositivo",
    "instructions": "Para conectar su dispositivo, inicie la aplicación cliente en su dispositivo e introduzca el código de emparejamiento que se muestra.",
    "client_hint": "Antes de poder conectar su dispositivo, asegúrese de haber descargado e instalado la aplicación cliente.",
    "install_client": "Instalar aplicación cliente",
    "failure": "La conexión falló. El código de emparejamiento que introdujo ({{code}}) podría ser incorrecto o haber caducado."
  },
  "clients": {
    "coming_soon": "Disponible bajo petición",
    "go_to_overview": "Instalar otra aplicación cliente",
    "connected": "Conectado",
    "connected_clients": "Dispositivos emparejados",
    "active": "Activo",
    "set_active": "Seleccionar",
    "title": "Instalar aplicación cliente",
    "instructions": "Para disfrutar de la experiencia completa, descargue e instale la aplicación cliente en su dispositivo. Actualmente se admiten las siguientes plataformas:",
    "download_for_quest": "Meta",
    "download_for_focus": "VIVE",
    "download_for_pico": "PICO",
    "download_for_windows": "Windows",
    "connect_hint": "Después de instalar la aplicación cliente, continúe con la conexión de su dispositivo.",
    "connect": "Conectar dispositivo",
    "installation_title": "Instalar el cliente para {{device}}",
    "device": {
      "wave": "VIVE",
      "meta": "Meta Quest",
      "pico": "PICO",
      "desktop": "Windows",
      "apple_vision_pro": "Apple Vision Pro",
      "magic_leap": "Magic Leap"
    },
    "desktop_client": {
      "intro": "Para poder descargar y ejecutar aplicaciones localmente, descargue primero el instalador de la aplicación cliente para Windows que aparece a continuación:",
      "download_cta": "Descargar instalador",
      "installation_instructions": "Después de descargar el instalador, siga las instrucciones de instalación para instalar la aplicación cliente en su ordenador con Windows."
    },
    "installation_methods": {
      "intro": "Para instalar la aplicación cliente para {{device}}, elija uno de los siguientes métodos:",
      "sideloading": {
        "title": "Instalación lateral (sideloading)",
        "requirements": "Instalar el cliente mediante sideloading requiere que su {{device}} tenga activado el modo de desarrollador.",
        "download_first": "Para instalar la aplicación cliente mediante sideloading, descargue primero el <1>apk</1> de la aplicación que aparece a continuación:",
        "download": "Descargar apk",
        "method_intro": "Después de descargar el apk en su ordenador, siga la guía para instalar la aplicación en su {{device}} mediante sideloading:",
        "recommended": "recomendado",
        "official_guide": "guía oficial"
      },
      "meta_applab": {
        "title": "Meta Store",
        "text": "Para instalar la aplicación cliente para su dispositivo Quest a través de Meta Store, simplemente haga clic en el siguiente botón y siga las instrucciones:",
        "cta": "Ir a Meta Store"
      },
      "vive_business_appstore": {
        "title": "VIVE Business AppStore",
        "text": "Para instalar la aplicación cliente para su dispositivo VIVE a través de VIVE Business App Store, simplemente haga clic en el siguiente botón y siga las instrucciones:",
        "cta": "Ir a VIVE Business AppStore"
      },
      "pico_enterprise_store": {
        "title": "Pico Enterprise Store",
        "text": "Para instalar la aplicación cliente para su dispositivo PICO Enterprise, abra la tienda en su dispositivo PICO Enterprise y busque 'Innoactive Portal'."
      },
      "recommended": "Recomendado",
      "mdm": {
        "title": "Gestión de dispositivos móviles (MDM)",
        "intro": "Para distribuir la aplicación cliente para {{device}} a través de un sistema de gestión de dispositivos móviles (MDM), siga la guía que aparece a continuación.",
        "copy_download_url": "Haga clic para copiar la URL del apk de la aplicación cliente",
        "steps": {
          "login": {
            "title": "Inicie sesión en la consola de administración de MDM",
            "text": "Acceda a la consola administrativa de su plataforma MDM con sus credenciales. Normalmente esto se puede hacer a través de un navegador web."
          },
          "navigate_to_app_management": {
            "title": "Vaya a la gestión de aplicaciones",
            "text": "Vaya a la sección de la consola MDM donde puede gestionar aplicaciones, a menudo etiquetada como 'Apps', 'Aplicaciones' o 'Catálogo de aplicaciones'."
          },
          "add_application": {
            "title": "Añada la aplicación",
            "text": "Busque una opción para 'Añadir', 'Subir' o 'Desplegar' una nueva aplicación. Esto puede incluir opciones para subir un APK directamente o enlazar a un APK externo. Puede usar la siguiente URL para descargar el APK y subirlo al sistema MDM o para enlazar el APK externamente:"
          },
          "choose_deployment_method": {
            "title": "Elija el método de despliegue",
            "text": "Según su plataforma MDM, puede tener distintas opciones para añadir la aplicación.",
            "options": {
              "direct_upload": {
                "title": "Subida directa",
                "text": "Seleccione 'Subir' y elija el archivo APK de su ordenador para subirlo directamente al sistema MDM."
              },
              "external_link": {
                "title": "Enlace externo",
                "text": "Seleccione 'Añadir por URL' o 'Enlazar aplicación externa' y proporcione la URL donde está alojado el APK."
              }
            }
          },
          "configure_app_settings": {
            "title": "Configure los ajustes de la aplicación",
            "text": "Introduzca los datos necesarios sobre la aplicación, como nombre, descripción, versión y cualquier otro metadato que requiera su plataforma MDM.",
            "text2": "Defina los ajustes de despliegue, como a qué usuarios o grupos debe estar disponible la aplicación y cualquier acceso condicional basado en el cumplimiento del dispositivo."
          },
          "set_permissions_and_policies": {
            "title": "Establezca permisos y políticas",
            "text": "Configure los permisos específicos de la aplicación necesarios para su funcionamiento.",
            "text2": "Establezca políticas de seguridad y reglas de tratamiento de datos acordes con los estándares de la organización."
          },
          "deploy_the_application": {
            "title": "Despliegue la aplicación",
            "text": "Asigne la aplicación a grupos o usuarios específicos. Según su elección, haga clic en 'Publicar', 'Desplegar' o una opción similar para que la aplicación esté disponible a través del MDM."
          },
          "verify_deployment": {
            "title": "Verifique el despliegue",
            "text": "Supervise el estado del despliegue a través de la consola MDM para asegurarse de que la aplicación se distribuye e instala correctamente en los dispositivos previstos.",
            "text2": "Compruebe si hay errores de instalación y resuelva cualquier problema notificado por los usuarios."
          },
          "manage_updates_and_support": {
            "title": "Gestione las actualizaciones y el soporte",
            "text": "Compruebe periódicamente si hay nuevas versiones de la aplicación y repita la subida o actualice el enlace externo según sea necesario.",
            "text2": "Ofrezca soporte continuo a los usuarios finales y mantenga una comunicación clara sobre las actualizaciones de la aplicación y las nuevas funciones."
          }
        }
      }
    },
    "download_for_apple_vision_pro": "Apple Vision Pro",
    "download_for_magic_leap": "Magic Leap 2"
  },
  "footer": {
    "terms": "Condiciones de uso",
    "privacy": "Privacidad de datos",
    "legal": "Aviso legal",
    "version": "Versión (Web): {{version}}",
    "powered_by": "Este servicio es ofrecido por Innoactive. <2>innoactive.io/portal</2>",
    "support": "Soporte"
  },
  "header": {
    "search": "Buscar",
    "language": "Idioma",
    "logout": "Cerrar sesión",
    "security": "Seguridad",
    "streaming": "Streaming"
  },
  "search": {
    "no_app": "Parece que no hay aplicaciones que coincidan con su término de búsqueda \"{{term}}\".",
    "placeholder": "Buscar aplicaciones",
    "minimum_chars": "Introduzca al menos tres caracteres para empezar a buscar",
    "filter": {
      "label": "Filtrar",
      "rendering": {
        "title": "Renderizado",
        "label": "Tipo de renderizado: {{type}}",
        "all": "Cualquier modo de renderizado",
        "local": "Solo local",
        "streaming": "Solo streaming"
      },
      "device": {
        "title": "Dispositivo",
        "label": "Tipo de dispositivo: {{type}}",
        "all": "Todos los dispositivos",
        "win-non-vr": "Navegador",
        "win-vr": "Windows VR",
        "quest": "Meta Quest",
        "wave": "HTC Vive",
        "pico": "PICO",
        "magic-leap": "Magic Leap"
      }
    }
  },
  "languages": {
    "en": "Inglés",
    "de": "Alemán",
    "es": "Español"
  },
  "details": {
    "unsupported": "No compatible",
    "launch_in_cloud": "Transmitir a gafas XR",
    "launch_browser": "Transmitir al navegador",
    "launch_on_standalone_device": "Ejecutar en gafas XR",
    "launch_locally": "Descargar y ejecutar localmente",
    "edit": "Editar en el panel de control",
    "available_clients": "{{clients}} disponibles",
    "vr_clients": "dispositivos VR",
    "generic_clients": "dispositivos",
    "pair_vr_device": "Conectar dispositivo",
    "stream_to_device": "Transmitir a {{name}}",
    "launch_on_device": "Ejecutar en {{name}}",
    "not_installed_on_device": "No instalado en {{name}}",
    "install_on_device": "Instalar y ejecutar en {{name}}",
    "install_on_server": "Instalar en el servidor de streaming",
    "queue_for_installation": "Poner en cola para instalación",
    "fast_launch_tooltip": "Inicio rápido: la aplicación está preinstalada en el servidor",
    "installing": "Solicitando instalación",
    "installed_addendum": " (Instalada)",
    "related_apps": "Aplicaciones relacionadas",
    "not_connected_title": "¡Desconectado!",
    "not_connected_text": "Actualmente no hay conexión con el servicio en segundo plano. Restablezca la conexión o póngase en contacto con un administrador.",
    "streaming_preferences": "Preferencias de streaming",
    "download_apk": "Descargar .apk",
    "download_exe": "Descargar .zip",
    "download_windows_vr": "Descargar versión Windows VR (.zip)",
    "download_windows_non_vr": "Descargar versión Windows sin VR (.zip)",
    "no_actions_available_title": "No hay acciones disponibles",
    "no_actions_available": "No hay acciones disponibles para esta aplicación. Conecte un dispositivo adecuado para ejecutar la aplicación y verifique la configuración de la aplicación.",
    "changelog": "Registro de cambios",
    "no_changelog_available": "No se ha proporcionado un registro de cambios",
    "not_installed_addendum": " (No instalada)",
    "connecting_title": "Conectando ...",
    "connecting_text": "Intentando (re)establecer la conexión con el servicio...",
    "changelog_show_more": "Mostrar más...",
    "stream_preferences_wizard": "Asistente de ubicación del servidor",
    "switch_version": "Cambiar versión",
    "device_incompatible_tooltip": "El dispositivo seleccionado no admite streaming cifrado.",
    "disconnected_tooltip": "Sin conexión con el servicio.",
    "download_windows": "Descargar versión para <2>{{platforms}}</2>",
    "standalone_app_not_installed": "La aplicación no está instalada en su dispositivo. Instale la aplicación para poder ejecutarla.",
    "standalone_app_not_installed_title": "Aplicación no instalada"
  },
  "request_access": {
    "request_access": "Solicitar acceso",
    "access_requested": "Acceso solicitado ({{relativeDate}}).",
    "message_label": "Indique algo de información sobre por qué necesita acceso ...",
    "cancel": "Cancelar",
    "submit": "Enviar",
    "pending_request": "Ya ha solicitado acceso. Su mensaje fue: ",
    "handled_externally": "Vaya a <2>{{url}}</2> para solicitar acceso a esta aplicación."
  },
  "launch": {
    "launch_app": "Iniciando aplicación",
    "launch_app_with_name": "Iniciar <strong>\"{{name}}\"</strong>",
    "custom_protocol_prompt_instruction": "Haga clic en <strong>\"Abrir Portal Desktop Client\"</strong> en el cuadro de diálogo que muestra su navegador.",
    "custom_protocol_prompt_reopen": "Si no ve ningún cuadro de diálogo, asegúrese de tener instalado Portal Desktop Client\ny haga clic en <strong>\"{{action}}\"</strong> a continuación.",
    "custom_protocol_prompt_reopen_action": "Iniciar {{name}}",
    "desktop_client_not_installed_question": "¿No tiene instalado Portal Desktop Client?",
    "download_now": "Descargar ahora",
    "check_desktop_client_installation": "Esperando al Desktop Client",
    "app_not_found_invalid_id": "ID de aplicación no válido.",
    "app_not_found_title": "No se pudo cargar la información de la aplicación.",
    "app_not_found": "Esto puede deberse a permisos insuficientes o a que la aplicación no exista. Verifique sus permisos de acceso o póngase en contacto con el soporte para obtener ayuda.",
    "region_incompatible": "Región incompatible",
    "region_incompatible_detail": "Nuestros sistemas han detectado que la región deseada ({{ preferredRegion }}) no admite streaming para la aplicación seleccionada o no podemos garantizar que la región sea accesible desde su dispositivo. Le recomendamos seguir usando la región {{ bestRegion }} en su lugar.",
    "region_incompatible_force_continue": "Si sabe lo que hace, también puede hacer clic en el siguiente enlace para <2>ignorar esta advertencia y seguir usando \"{{ preferredRegion }}\"</2> a riesgo de una experiencia degradada.",
    "force_continue": "Mantener {{ regionName }}",
    "region_no_capacity": "Región sin capacidad",
    "region_no_capacity_detail": "La región deseada {{ preferredRegion }} no se puede usar en este momento por falta de recursos de renderizado.",
    "region_no_capacity_loading": "Tenga paciencia mientras buscamos regiones alternativas para renderizar...",
    "no_region_available": "No hay servidor de streaming disponible",
    "no_region_available_detail": "No hay ningún servidor de streaming compatible para la aplicación seleccionada. Póngase en contacto con el administrador de su organización.",
    "back": "Atrás",
    "cancel": "Cancelar",
    "continue": "Usar {{ regionName }}",
    "launch_type_unsupported": "¡Tipo de sesión no compatible!",
    "region_no_capacity_redirect_detail": "La región deseada {{ preferredRegion }} no se puede usar en este momento por falta de recursos de renderizado. Hemos redirigido automáticamente su sesión para que se ejecute en {{ alternativeRegion }} en su lugar.",
    "region_no_capacity_alternative": "¿Puede volver a intentarlo más tarde o seguir usando la región {{ alternativeRegion }} en su lugar?",
    "unknown_region": "Región desconocida",
    "select_target_device": "Seleccione cuál de sus dispositivos conectados debe usarse para ejecutar la sesión:",
    "select_vm_size": "Seleccione el nivel de rendimiento que desea usar para ejecutar su aplicación en {{ regionName }}:",
    "force_continue_with_vm_size": "Usar {{ regionName }} ({{ vmSize }})",
    "region_requires_vm_size_change": "La región requiere configuración adicional",
    "back_to_recommendation": "Volver a la recomendación",
    "vm_size_too_small": "El nivel de rendimiento seleccionado ({{ selectedVmSize }}) es inferior al requerido por la aplicación ({{ targetVmSize }}). Tenga en cuenta que ignorar este hecho puede provocar un rendimiento degradado.",
    "no_app_build_for_launch": "No se encontró ninguna versión de la aplicación compatible para el inicio solicitado.",
    "application_not_installed_on_device": "La aplicación no está instalada en el dispositivo. ¡Instálela primero!",
    "no_matching_launch_configuration": "No se pudo identificar cómo iniciar la aplicación seleccionada",
    "select_launch_configuration": "Seleccione cómo desea que se inicie la aplicación",
    "potentially_uninstalled_desktop_client": "Parece que aún no tiene instalado Portal Desktop Client; asegúrese primero de que esté instalado en su PC con Windows.",
    "potentially_uninstalled_desktop_client_title": "¿Portal Desktop Client no está instalado?",
    "go_to_desktop_client_installation_instructions": "Mostrar instrucciones de instalación",
    "potentially_uninstalled_desktop_client_dialog_close": "Cerrar",
    "desktop_client_unsupported_platform": "El inicio local de esta aplicación no es compatible con su dispositivo. Cambie a un PC con Windows para iniciar esta aplicación localmente o use otra forma de iniciarla.",
    "show_alternative_launch_modes": "Iniciar la aplicación de otra forma",
    "device_incompatible": "Dispositivo incompatible",
    "device_not_supporting_encrypted_vr_streaming_error": "El dispositivo que seleccionó no se puede usar para streaming VR cifrado. Asegúrese de haber concedido el permiso necesario en el dispositivo para habilitar el streaming cifrado a las gafas XR.",
    "error_fetching_encryption_setting": "Error al cargar las preferencias del usuario / las políticas de la organización",
    "legacy": {
      "unsupported_launch_mode": "¡Modo de inicio no compatible!"
    },
    "latency_test_required_info": "Identificando la mejor ubicación de servidor ...",
    "selected_region_incompatible_no_alternative": "Nuestros sistemas han detectado que la región deseada ({{ preferredRegion }}) no admite streaming para la aplicación seleccionada o no podemos garantizar que la región sea accesible desde su dispositivo. En este momento no hay ningún servidor de streaming alternativo disponible para usted. Póngase en contacto con un administrador."
  },
  "notifications": {
    "title": "Notificación de sesión",
    "MaxSoftSessionRunTime": "Su sesión lleva bastante tiempo en ejecución. Finalícela si ya no la necesita.",
    "MaxSessionRunTime": "Su sesión ha superado el tiempo máximo de ejecución y se finalizará automáticamente.",
    "HighLatency": "Advertencia de latencia alta para la sesión actual en {{ region }} {{ latency }}ms. El rendimiento podría verse afectado.",
    "SessionInactivityTimeoutTime": "Sesión finalizada porque el dispositivo estuvo inactivo demasiado tiempo.",
    "HotVirtualMachineWithPreInstalledAppsUsed": "Esta sesión utiliza una instancia reservada activa con aplicaciones preinstaladas.",
    "VirtualMachineDestroyedBecauseOfError": {
      "generic": "No se pudo aprovisionar la máquina virtual debido a un error técnico. Vuelva a intentarlo.",
      "CloudProviderNoAvailability": "No hay máquinas virtuales disponibles en la región de nube seleccionada. Pruebe con otra región o vuelva a intentarlo más tarde.",
      "ImageNotFound": "No se encontró la imagen de máquina virtual requerida. Póngase en contacto con el soporte.",
      "CouldNotProvision": "Se produjo un error de configuración de la infraestructura. Póngase en contacto con el soporte.",
      "title": "Error de infraestructura"
    }
  },
  "streaming_server_not_ready": {
    "title": "Se está preparando el servidor de streaming",
    "description": "Su servidor de streaming personal aún está instalando aplicaciones. Esto puede tardar unos minutos.",
    "wait_option": "Volver y esperar",
    "new_server_option": "Obtener un nuevo servidor de streaming",
    "new_server_warning": "Obtener un nuevo servidor destruirá su servidor pendiente para evitar costes adicionales."
  },
  "app": {
    "streaming_server_preparing": "Preparando servidor",
    "streaming_server_details": "Detalles del servidor de streaming",
    "streaming_server_status": "Estado",
    "preparing": "Preparando",
    "streaming_server_region": "Región",
    "streaming_server_size": "Tamaño",
    "streaming_server_apps": "Aplicaciones instaladas",
    "streaming_server_created": "Creado",
    "streaming_server_preparing_message": "Su servidor de streaming se está preparando. Esto suele tardar unos minutos.",
    "schedule_session": "Programar sesión"
  },
  "session": {
    "pairing": {
      "no_device_pico": "Empareje su dispositivo PICO para continuar con el inicio de la aplicación.",
      "no_device_quest": "Empareje su dispositivo Quest para continuar con el inicio de la aplicación.",
      "no_device_wave": "Empareje su dispositivo Vive para continuar con el inicio de la aplicación.",
      "connect_standalone_device": "Conecte unas gafas XR autónomas para continuar con el inicio de la aplicación."
    },
    "end": "Finalizar sesión",
    "abort": "Cancelar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "idle": "No hay sesión activa",
    "browse": "Explore las aplicaciones disponibles",
    "ready": "¡La sesión está lista!",
    "ready_short": "¡Sesión lista!",
    "notification": "¡Haga clic aquí para ir a su sesión ahora!",
    "ready_instructions": "Continúe con \"{{ device }}\".",
    "ready_instructions_xr": "Póngase sus \"{{ device }}\" para continuar.",
    "ready_instructions_desktop": "Continúe en su escritorio.",
    "seconds": "s",
    "seconds_plural": "s",
    "minutes": "min",
    "minutes_plural": "min",
    "running": "¡La sesión está en ejecución!",
    "app_running": "\"{{name}}\" se está ejecutando en {{ device }}.",
    "app_running_browser": "\"{{name}}\" se está ejecutando. Se le conectará en breve...",
    "running_on": "Ejecutándose en: <strong>{{name}}</strong>",
    "networking_problems_title": "Se detectaron problemas de rendimiento de red",
    "networking_problems": "Hemos detectado problemas de rendimiento de red en sus gafas XR.",
    "networking_latency": "• La latencia de su red es demasiado alta",
    "networking_bandwidth": "• Su ancho de banda no es suficiente",
    "networking_unstable": "• Su conexión parece demasiado inestable",
    "networking_help": "Para más información, visite nuestro",
    "abort_dialog": {
      "title": "Cancelar sesión",
      "are_you_sure": "¿Seguro que desea finalizar esta sesión?"
    },
    "session_already_running_dialog": {
      "title": "Sesión existente detectada",
      "body": "Al confirmar a continuación, su sesión existente se finalizará y se iniciará una nueva sesión para ejecutar la aplicación seleccionada.\n\nHaga clic en cancelar para ir a la sesión activa en su lugar."
    },
    "application_requires_update_dialog": {
      "title": "Nueva versión lista",
      "body": "Hay una nueva versión de la aplicación lista para instalar. ¿Desea instalarla?"
    },
    "session_error_dialog": {
      "title": "Parece que hay un problema con su sesión",
      "continue": "Descartar",
      "additional_info": "Use el ID de sesión que aparece a continuación para obtener más ayuda del soporte:",
      "report": "Soporte",
      "report_summary_session": "Problema en la sesión {{ sessionId }}",
      "report_summary_starting_session": "Problema al iniciar una sesión",
      "report_description": "{{ errorMessage }}.\n\nProporcione información adicional sobre lo que ocurrió antes de que se produjera el error.",
      "title_startup": "Encontramos un problema al intentar iniciar la sesión"
    },
    "unexpected_error": "Se produjo un error inesperado",
    "go_to_session": "Ir a la sesión",
    "ready_acknowledge": "Ir a la sesión",
    "active": "Sesión activa",
    "ready_in": "Lista en",
    "ending": "Finalizando ...",
    "notification_enabled_title": "Notificaciones activadas",
    "notification_enabled_text": "Le notificaremos cuando su sesión esté lista aunque no esté en esta página.",
    "notification_denied_title": "No se pudieron activar las notificaciones",
    "notification_denied_text": "Parece que su navegador prohíbe las notificaciones de esta página. ¡Compruebe la configuración de su navegador!",
    "skip": "Omitir",
    "update": "Instalar",
    "debug": {
      "id": "ID de sesión",
      "server_ip": "Dirección IP",
      "latency": "Latencia",
      "enable_debug": "Activar modo de depuración",
      "enable_debug_tooltip": "Abrir puertos VNC y RDP en la VM",
      "debug_enable_tooltip": "El modo de depuración ya está activado",
      "duration": "Duración",
      "app_version_api_id": "ID de versión",
      "app_api_id": "ID de aplicación",
      "vm_image": "Imagen de VM",
      "header": "Información de la sesión",
      "streaming_server": "Servidor de streaming",
      "xr_encryption_enabled": "Cifrado de extremo a extremo",
      "streaming_protocols": "Protocolos de streaming",
      "xr_device": "Dispositivo",
      "xr_gateway_used": "a través de la puerta de enlace XR"
    },
    "preparing": "¡Preparando su sesión!",
    "notified_when_ready": "Le avisaremos cuando terminen los preparativos.",
    "enable_notifications_to_be_notified": "Para recibir un aviso cuando esté lista, haga clic <2>aquí</2>",
    "taking_longer_than_expected": "El streaming comenzará pronto.",
    "calculating_wait_time": "Estimando el tiempo de espera...",
    "rate_dialog": {
      "title": "¿Qué calidad tuvo su experiencia?",
      "cancel": "Descartar",
      "rate_action": "Enviar",
      "placeholder": "Más información"
    },
    "switch_organization": "Cambiar a {{organizationName}}",
    "switch_organization_info": "Para ver esta sesión, cambie a la organización {{organizationName}} o finalice la sesión para iniciar una nueva.",
    "application": "Aplicación"
  },
  "spectator": {
    "actions": {
      "copy": "Copiar texto",
      "paste": "Pegar texto"
    },
    "connection": {
      "new": "Conceda acceso a su micrófono",
      "establishing": "Estableciendo conexión",
      "connecting": "Conectando",
      "connected": "Conectado. Esperando a que comience la transmisión",
      "disconnected": "Desconectado",
      "closed": "Conexión cerrada",
      "no_frames": "Esperando a que comience la transmisión...",
      "no_frames_hint": "Aún no hemos recibido ningún vídeo. Puede tratarse de un breve retraso, o quizá la aplicación no esté mostrando nada que podamos transmitir. Si no aparece nada al cabo de un rato, pruebe a reiniciar la aplicación o a comprobar su conexión."
    },
    "microphone": {
      "failed": "Error al activar el micrófono",
      "unmuting-failed": "No se pudo activar el sonido del micrófono. Es posible que se haya denegado el acceso al micrófono en este navegador."
    },
    "clipboard": {
      "error": {
        "missing-permission-title": "Acceso al portapapeles denegado",
        "missing-permission-description": "Compruebe la configuración de su navegador y permita el acceso al portapapeles."
      }
    },
    "fullscreen": {
      "turn-to-enable-title": "Gire su dispositivo",
      "turn-to-enable-description": "Para activar el modo de pantalla completa, cambie la orientación de su dispositivo a modo horizontal.",
      "turn-to-disable-title": "Gire su dispositivo",
      "turn-to-disable-description": "Para desactivar el modo de pantalla completa, cambie la orientación de su dispositivo a modo vertical."
    },
    "audio": {
      "blocked_by_browser_policy": "La política de su navegador impide actualmente reproducir audio hasta que active el sonido manualmente haciendo clic a continuación.",
      "unmute": "Activar sonido",
      "ignore": "Ignorar"
    },
    "remoteUrls": {
      "text": "La aplicación intentó abrir la siguiente URL de forma remota. Haga clic a continuación para abrirla en su navegador en su lugar:",
      "title": "URL remotas"
    },
    "windows": {
      "title": "Ventanas disponibles"
    }
  },
  "legal": {
    "title": "Información legal",
    "managing_director": "Director gerente",
    "contact": "Contacto",
    "other": "Otra información legal",
    "vat": "NIF / IVA",
    "third_party": {
      "title": "Licencias de terceros",
      "description": "Esta aplicación incluye software de terceros, distribuido conforme a sus propias condiciones de licencia:",
      "oss": "Atribución y textos completos de las licencias de los paquetes de código abierto sobre los que se basa esta aplicación.",
      "cloudxr": "Condiciones de licencia del SDK NVIDIA CloudXR, utilizado para la renderización remota.",
      "dcv": "Contrato de licencia de usuario final del SDK Amazon DCV Web Client, utilizado para la transmisión.",
      "dcv_notices": "Atribución de Amazon sobre el software de código abierto incluido en su cliente."
    }
  },
  "privacy": {
    "title": "Privacidad de datos"
  },
  "terms": {
    "title": "Términos y condiciones"
  },
  "list": {
    "empty": {
      "title": "¡Vaya!",
      "description": "¡Parece que (todavía) no hay aplicaciones disponibles para usted!",
      "action_description": "Todavía no hay aplicaciones. Suba la primera desde el panel de control.",
      "action_description_no_permission": "No hay aplicaciones disponibles. Pida a un administrador que le asigne permisos para acceder a las aplicaciones.",
      "action_label": "Gestionar aplicaciones"
    },
    "view": {
      "categories": "Categorías",
      "all": "Todas las apps"
    },
    "no_results": "Ninguna aplicación coincide con los filtros seleccionados."
  },
  "device": {
    "came_online_title": "Dispositivo en línea",
    "came_online": "Su dispositivo {{name}} acaba de conectarse",
    "went_offline_title": "Dispositivo desconectado",
    "went_offline": "Su dispositivo {{name}} acaba de desconectarse"
  },
  "menu": {
    "control_panel": "Panel de control",
    "admin_panel": "Panel de administración"
  },
  "preferences": {
    "dialog": {
      "title": "Preferencias",
      "explanation": "Puede adaptar sus preferencias de renderizado en la nube para optimizar el rendimiento según su caso de uso específico y su ubicación actual. Le recomendamos encarecidamente no cambiar estos ajustes a menos que sea absolutamente necesario. Use el Asistente de ubicación del servidor para determinar su mejor ubicación de servidor.",
      "preferredCloudProvider": "Proveedores de nube activos",
      "savedTitle": "Cambios guardados",
      "saved": "Sus preferencias de renderizado en la nube se actualizaron correctamente.",
      "savedSecurity": "Sus preferencias de seguridad se actualizaron correctamente.",
      "errorTitle": "Error",
      "error": "No se pudieron guardar los cambios.",
      "regions": "Regiones disponibles",
      "automaticModeLabel": "Activar modo automático",
      "manualModeLabel": "Activar modo manual",
      "vm_sizes": "Tamaños",
      "savedStreamingProtocol": "Sus preferencias de streaming se actualizaron correctamente."
    },
    "map": {
      "setaspreferred": "Seleccionar",
      "ispreferred": "Seleccionada",
      "distance": "Distancia (aprox.)",
      "latency": "Latencia",
      "region": "Región",
      "disabled": "No utilizable"
    },
    "preferred_region_unavailable": "Región no disponible",
    "preferred_region_unavailable_details": "La región deseada \"{{ preferredRegion }}\" no está disponible en este momento o no se puede usar para streaming. Elija otra región para usar el streaming o active el modo automático.",
    "preferred_region_unsupported": "Región no compatible",
    "preferred_region_unsupported_details": "Nuestros sistemas han detectado que la región deseada \"{{ preferredRegion }}\" no admite el streaming de la aplicación seleccionada. Le recomendamos elegir otra región para usar el streaming o activar el modo automático. Si sabe lo que hace, también puede optar por ignorar esta advertencia y seguir usando \"{{ preferredRegion }}\" a riesgo de una experiencia degradada",
    "security_preferences": "Seguridad",
    "region_preference": "Ubicación del servidor",
    "security": {
      "encrypt_vr_stream": "Cifrar transmisiones VR",
      "encrypt_vr_stream_help_text_disabled": "Usar el streaming VR sin cifrado puede ofrecer menor latencia y una mejor experiencia de usuario a costa de una menor seguridad.",
      "encrypt_vr_stream_help_text_enabled": "El cifrado del streaming VR aumenta la seguridad y es muy recomendable.",
      "debug_mode": "Activar modo de depuración de la VM",
      "debug_mode_help_text_disabled": "El modo de depuración está desactivado en la VM de forma predeterminada",
      "debug_mode_help_text_enabled": "El modo de depuración está activado en la VM de forma predeterminada",
      "policies_deny_encrypt_vr_stream_change": "Las políticas de su organización le impiden cambiar este ajuste. Póngase en contacto con su administrador."
    },
    "streaming": {
      "custom_vm_image": "Imagen de VM (personalizada)",
      "custom_vm_image_help_text": "Especificar arriba una imagen de máquina virtual (VM) personalizada permite ejecutar una aplicación en una máquina con distintos preajustes o funciones. Los valores posibles para este ajuste dependen del despliegue. Tenga en cuenta que no todas las imágenes de VM están disponibles en todas las regiones de streaming.",
      "vm_id": "ID de máquina virtual",
      "vm_id_help_text": "Especifique un ID de VM para garantizar que las sesiones consecutivas se ejecuten en la misma VM"
    },
    "protocols": {
      "use_xr_gateway": "Usar puerta de enlace para streaming XR",
      "use_xr_gateway_help_text_disabled": "En ubicaciones seleccionadas puede usar una puerta de enlace centralizada para conectarse a transmisiones XR. Esto añade una sobrecarga mínima (latencia).",
      "use_xr_gateway_help_encryption_required": "Para usar una puerta de enlace para el streaming XR, el cifrado debe estar activado."
    },
    "advanced": "Avanzado"
  },
  "invitation": {
    "accepted": {
      "title": "¡Bienvenido a {{name}}!",
      "description": "Ha aceptado la invitación correctamente y ya puede empezar a explorar el contenido disponible."
    }
  },
  "vmUpgradeNotification": {
    "title": "Nivel de rendimiento mejorado",
    "description": "Su sesión se inició en un servidor de streaming de mayor rendimiento para reducir el tiempo de inicio."
  },
  "or": "o",
  "featureFlags": {
    "title": "Indicadores de funciones",
    "description": "Los indicadores de funciones permiten activar o desactivar ciertas funciones (¡experimentales!). Las funciones activadas aquí solo se aplican a su cuenta de usuario y únicamente dentro de la organización activa actualmente."
  },
  "server_location_wizard": {
    "region": "Región",
    "cloud_provider": "Proveedor de nube",
    "distance": "Distancia (aprox.)",
    "latency": "Latencia",
    "hide_details": "Ocultar detalles",
    "show_details": "Mostrar detalles",
    "restart_test": "Reiniciar comprobaciones",
    "title": "Asistente de ubicación del servidor",
    "test_description": "Para optimizar la experiencia de streaming, estamos comprobando las ubicaciones de renderizado para encontrar la mejor para usted.",
    "network": "Red",
    "your_pc": "Su PC",
    "cloud_rendering_infrastructure": "Servidor de streaming",
    "success_header": "¡Se identificó la mejor ubicación de servidor!",
    "keep_page_open_warning": "Para obtener los mejores resultados, detenga cualquier descarga que pueda estar en curso, mantenga esta página abierta y no cambie a otra pestaña mientras se ejecutan las comprobaciones automáticas.",
    "close": "Cerrar asistente",
    "latency_table_description": "A continuación verá una lista de todas las ubicaciones de renderizado disponibles desde las que puede transmitir una aplicación. Puede (re)evaluar manualmente ciertas ubicaciones para determinar su rendimiento para el streaming o seleccionar una manualmente para anular la selección automática.",
    "latency_table_select_all": "Seleccionar todas (en esta página)",
    "check_selected_regions": "Comprobar ubicaciones seleccionadas",
    "check_selected_regions_button_disabled_hint": "Primero seleccione algunas ubicaciones para comprobar",
    "cancel": "Cancelar",
    "proceed": "Continuar",
    "heading": "Buscador de ubicación del servidor",
    "prevent_navigation_title": "¿Cancelar?",
    "abort_dialog_body": "Las comprobaciones de latencia aún se están ejecutando. ¿Seguro que desea salir?",
    "prevent_navigation_abort": "Cancelar y salir",
    "prevent_navigation_stay": "Continuar",
    "latency_test_running": "Para obtener los mejores resultados, mantenga esta página en primer plano mientras las comprobaciones están en curso."
  },
  "createRenderMachine": {
    "toast": {
      "title": "Servidor de streaming solicitado",
      "description": "Se ha solicitado el servidor de streaming. Puede tardar algún tiempo hasta que la máquina esté lista para usarse"
    },
    "toast_error": {
      "title": "No se pudo crear el servidor de streaming",
      "description": "No se pudo crear el servidor de streaming. Vuelva a intentarlo más tarde"
    }
  },
  "destroyRenderMachine": {
    "toast": {
      "title": "Destrucción de la máquina solicitada correctamente",
      "description": "La máquina se destruirá"
    },
    "toast_error": {
      "title": "Se produjo un error durante la destrucción de la máquina",
      "description": "No se pudo solicitar la destrucción de la máquina. Vuelva a intentarlo más tarde."
    }
  },
  "streaming_server": {
    "terminate_dialog": {
      "title": "Finalizar servidor de streaming",
      "are_you_sure": "¿Seguro que desea finalizar y eliminar este servidor de streaming?",
      "cancel": "Cancelar",
      "confirm": "Confirmar"
    },
    "stream_button": {
      "destroy": "Finalizar",
      "cancel": "Cancelar servidor de streaming",
      "create_button": "Crear servidor de streaming",
      "expires_in_time": "Caduca en {{time}} h",
      "expired": "Caducado"
    },
    "status": {
      "provisioning_infrastructure": "Aprovisionando servidor de streaming",
      "infrastructure_ready": "Recursos del servidor de streaming listos",
      "booting_server": "Iniciando servidor de streaming",
      "configuring_network": "Configurando la red del servidor",
      "installing_apps": "Instalando aplicaciones",
      "finalizing_setup": "Finalizando la configuración del servidor",
      "ready": "Listo",
      "preparing": "Preparando servidor de streaming",
      "errored": "El servidor de streaming falló",
      "creating": "Iniciando",
      "booting": "Iniciando",
      "installing": "Instalando",
      "default": "Transmitiendo"
    },
    "status_short": {
      "provisioning_infrastructure": "Aprovisionando",
      "infrastructure_ready": "Preparando",
      "booting_server": "Iniciando",
      "configuring_network": "Configurando",
      "installing_apps": "Instalando",
      "finalizing_setup": "Finalizando",
      "ready": "Listo",
      "preparing": "Preparando",
      "errored": "Fallido"
    },
    "intent_status": {
      "selecting_region": "Seleccionando la mejor región…"
    },
    "error_dialog": {
      "title": "Error del servidor de streaming",
      "RetriesExhausted": "No pudimos configurar su servidor de streaming. Se probaron todas las regiones disponibles, pero ninguna pudo aprovisionar un servidor correctamente.",
      "NoRegionFound": "No se pudo encontrar una región adecuada para aprovisionar un servidor de streaming.",
      "suggestion": "Suele ser un problema temporal. Vuelva a intentarlo en unos minutos o seleccione manualmente otra región en sus preferencias.",
      "additional_info": "Para obtener soporte, proporcione el siguiente ID de intento:",
      "report": "Contactar con soporte",
      "dismiss": "Descartar",
      "report_summary": "Error del servidor de streaming para el intento {{ intentId }}",
      "report_description": "El servidor de streaming no se pudo aprovisionar.\\nRegión: {{ region }}\\nTamaño: {{ size }}",
      "copy": "Copiar",
      "copied": "Copiado"
    },
    "extend": {
      "add_1_hour": "Ampliar 1 hora",
      "add_2_hours": "Ampliar 2 horas",
      "add_3_hours": "Ampliar 3 horas",
      "success": "Ampliación correcta",
      "success_description": "Servidor ampliado {{hours}} hora(s)",
      "error": "La ampliación falló",
      "error_description": "No se pudo ampliar el tiempo de caducidad del servidor"
    },
    "ready_notification": {
      "title": "Servidor de streaming listo",
      "message": "Su servidor de streaming ya está listo. La aplicación comenzará a transmitirse automáticamente.",
      "auto_proceed": "Comenzando en {{seconds}} segundos...",
      "cancel": "Cancelar",
      "proceed": "Iniciar streaming"
    },
    "region": {
      "select": "Seleccionar región",
      "manual": "(Manual)",
      "automatic": "Selección automática",
      "automatic_description": "Seleccionar automáticamente la mejor región según la latencia",
      "search": "Buscar",
      "search_placeholder": "Buscar regiones...",
      "filters": "Filtros",
      "clear_filters": "Borrar",
      "no_regions_found": "No se encontraron regiones",
      "cloud_providers": "Proveedores de nube"
    },
    "dialog": {
      "title": "Crear servidor de streaming",
      "sub_heading": "Seleccione las aplicaciones que desea preinstalar en su servidor de streaming. La preinstalación reduce los tiempos de carga de la sesión.",
      "selected_apps": "Aplicaciones seleccionadas",
      "available_apps": "Aplicaciones disponibles",
      "no_apps_selected": "Aún no se han seleccionado aplicaciones. Elija una o más aplicaciones a continuación.",
      "search_placeholder": "Buscar aplicaciones",
      "server_configuration_section": "Configuración del servidor",
      "server_recommendation": "Según su selección, recomendamos la siguiente configuración:",
      "change": "Cambiar",
      "cancel": "Cancelar",
      "selectNumberOfApps": "Seleccione las aplicaciones que deben preinstalarse. Preinstalar aplicaciones reduce el tiempo de carga de la sesión. Según las aplicaciones seleccionadas y la calidad de su conexión, hemos determinado que ",
      "bestRegion": " es la mejor región con el nivel de rendimiento ",
      "youCan": "Puede",
      "overwriteRegion": "cambiar la selección de ubicación manualmente",
      "additionallyYouCan": "Además, puede",
      "overwriteMachineSize": "cambiar manualmente el rendimiento de la máquina",
      "hideAndResetManualRegionSelection": "Restablecer y ocultar la selección de ubicación.",
      "hideAndResetManualVmSizeSelection": "Restablecer y ocultar la selección del nivel de rendimiento.",
      "createRenderMachine": "Crear servidor de streaming",
      "clearAllPreInstalledApps": "Borrar selección",
      "cannot_select_tooltip": "Se alcanzó el máximo de aplicaciones preinstaladas",
      "noValidRegionAvailable": "No pudimos encontrar una región para crear su servidor de streaming con los ajustes o las aplicaciones deseadas. Cambie sus ajustes o póngase en contacto con un administrador.",
      "overrideRegion": "Anular región",
      "overrideVmSize": "Anular nivel de rendimiento",
      "resetRegionToDefault": "Restablecer a la región recomendada",
      "resetVmSizeToDefault": "Restablecer al nivel de rendimiento recomendado"
    },
    "status_button": {
      "disable_button": "Haga clic para dejar de usar este servidor",
      "enable_button": "Haga clic para usar este servidor",
      "destroy_tooltip": "¿Destruir este servidor?",
      "active": "Activo",
      "select": "Seleccionar"
    },
    "conflict": {
      "title": "Problema de compatibilidad del servidor de streaming",
      "xr_gateway_not_supported": "Su servidor de streaming existente en {{region}} no admite la puerta de enlace XR, que actualmente requieren sus preferencias o la política de la organización.",
      "explanation": "Para continuar con el inicio de la aplicación, puede elegir una de las siguientes opciones:",
      "option_1_title": "Crear un nuevo servidor de streaming",
      "option_1_description": "Crear un nuevo servidor con las especificaciones requeridas.",
      "option_2_title": "Cambiar preferencias",
      "option_2_description_xr": "Desactivar el requisito de puerta de enlace XR.",
      "change_preferences_button": "Cambiar preferencias",
      "create_new_button": "Crear nuevo servidor",
      "vm_size_too_small": "Su servidor de streaming existente en la región {{region}} ({{currentSize}}) no cumple el requisito de tamaño mínimo ({{requiredSize}}) para esta aplicación.",
      "vm_size_explanation": "El rendimiento de su servidor de streaming existente es insuficiente para la aplicación solicitada. Debe crear un nuevo servidor de streaming con recursos suficientes para continuar.",
      "option_1_additional_info": "El servidor de streaming se creará en {{region}}.",
      "create_new_in_other_region_button": "Crear nuevo servidor ({{region}})",
      "disable_xr_gateway_button": "Desactivar puerta de enlace XR"
    }
  },
  "authorization_error": "Se produjo un error inesperado",
  "streamer": {
    "dcv": {
      "preferences": {
        "mode_responsiveness": "Mejor capacidad de respuesta",
        "mode_quality": "Mejor calidad",
        "mode_responsiveness_help": "Ofrece la experiencia más fluida.",
        "mode_quality_help": "Ofrece la mejor calidad de imagen.",
        "high_color_accuracy": "Alta precisión de color (YUV 4.4.4)",
        "high_color_accuracy_help": "El rendimiento del streaming podría verse afectado.",
        "streaming_mode": "Modo de streaming",
        "high_color_accuracy_enabled": "Activado",
        "high_color_accuracy_disabled": "Desactivado",
        "title": "Preferencias de DCV",
        "change": "Gestionar preferencias de DCV"
      },
      "high_color_accuracy_unsupported": "La alta precisión de color no es compatible",
      "resolution_capped_title": "Resolución remota limitada",
      "resolution_capped_description": "Esta máquina no puede ajustar su resolución al tamaño de la ventana, por lo que pueden aparecer barras negras alrededor del stream. Volver a conectar puede asignar una máquina compatible.",
      "stats": {
        "show": "Mostrar estadísticas de streaming",
        "hide": "Ocultar estadísticas de streaming",
        "fps": "FPS",
        "latency": "Latencia",
        "traffic": "Tráfico",
        "peak": "máx."
      }
    }
  },
  "user": {
    "preferences": "Preferencias",
    "scheduled_sessions": "Sesiones programadas",
    "expert_mode": "Modo experto",
    "expert_mode_description": "Actívelo para desbloquear funciones adicionales. Solo se recomienda para usuarios expertos.",
    "notifications_badge": "{{count}} elementos requieren atención"
  },
  "installable_app": {
    "queued": "La instalación de {{appName}} está en cola",
    "installing": "{{appName}} se está instalando ..."
  },
  "latency_checks": {
    "running_button": "Identificando el mejor servidor"
  },
  "organization": {
    "error_loading": "Error al obtener la información de la organización"
  },
  "branding": {
    "loading": "Cargando la personalización de la organización ...",
    "error_loading": "No se pudo cargar la personalización"
  },
  "generic": {
    "not_available_short": "N/D"
  },
  "schedule": {
    "modal": {
      "title": "Programar sesión",
      "edit_title": "Editar sesión",
      "application": "Aplicación",
      "name": "Nombre del evento",
      "name_placeholder": "Introduzca un nombre para esta sesión",
      "start_time": "Hora de inicio",
      "end_time": "Hora de finalización",
      "end_time_error": "La hora de finalización debe ser posterior a la de inicio",
      "max_duration_error": "La duración del evento no puede superar las {{maxHours}} horas",
      "participants": "Participantes",
      "select_user": "Seleccione un usuario para añadir",
      "search_user": "Buscar un usuario...",
      "no_users_found": "No se encontraron usuarios",
      "add_participant": "Añadir participante",
      "remove_participant": "Eliminar participante",
      "participants_required": "Invite al menos a un participante",
      "organizer_no_stream_access": "No tiene permiso para transmitir esta aplicación, por lo que no puede programar una sesión para ella. Haga clic para gestionar los permisos.",
      "include_self": "Incluirme como participante",
      "include_self_hint": "Desmárquelo si está programando en nombre de otra persona. Usted gestiona la sesión igualmente.",
      "requires_cloud": "Infraestructura en la nube",
      "cancel": "Cancelar",
      "schedule": "Programar",
      "update": "Actualizar sesión",
      "done": "Hecho",
      "success_title": "¡Sesión programada!",
      "success_description": "Su sesión se ha creado. Comparta el enlace de abajo con los participantes para que puedan confirmar su asistencia.",
      "rsvp_link": "Enlace de confirmación",
      "copy_link": "Copiar enlace",
      "rsvp_link_description": "Comparta este enlace con los participantes para confirmar su asistencia",
      "no_stream_access": "El usuario no tiene acceso al streaming. Haga clic para gestionar los permisos."
    },
    "list": {
      "title": "Sesiones programadas",
      "empty": "Aún no hay sesiones programadas",
      "column_name": "Nombre",
      "column_time": "Hora",
      "column_participants": "Participantes",
      "column_apps": "Aplicaciones",
      "apps": "aplicaciones",
      "past": "Pasadas",
      "ongoing": "En curso",
      "edit": "Editar",
      "delete": "Eliminar",
      "rsvp": "Confirmar",
      "open_rsvp": "Abrir página de confirmación",
      "copy_id": "Copiar ID",
      "copy_id_success": "ID copiado al portapapeles",
      "delete_title": "Eliminar sesión programada",
      "delete_confirm": "¿Seguro que desea eliminar \"{{name}}\"?",
      "cancel": "Cancelar",
      "filter": {
        "title": "Hora",
        "show_past": "Mostrar sesiones programadas pasadas"
      },
      "infrastructure": {
        "title": "Estado de la infraestructura",
        "ready": "Listo",
        "provisioning": "Aprovisionando...",
        "pending": "Pendiente",
        "not_accepted": "No aceptada",
        "not_required": "No requerida",
        "error": "Error",
        "no_permission": "Sin permiso",
        "no_permission_hint": "No tiene permiso para ver el estado de la infraestructura de otros participantes."
      },
      "rsvp_status": {
        "title": "Estado de confirmación",
        "accepted": "Aceptada",
        "declined": "Rechazada",
        "pending": "Pendiente"
      }
    },
    "toast": {
      "created": {
        "title": "Sesión programada",
        "description": "Su sesión se ha programado correctamente"
      },
      "updated": {
        "title": "Sesión actualizada",
        "description": "Su sesión se ha actualizado correctamente"
      },
      "deleted": {
        "title": "Sesión eliminada",
        "description": "Su sesión programada se ha eliminado"
      },
      "error": {
        "title": "Error",
        "description": "Se produjo un error. Vuelva a intentarlo."
      }
    },
    "rsvp": {
      "invitation": "Ha sido invitado a esta sesión",
      "organizer_not_participant": "Usted ha organizado esta sesión. No está en la lista de invitados, así que no hay nada que confirmar.",
      "participants": "participantes",
      "you": "Usted",
      "accept": "Aceptar",
      "decline": "Rechazar",
      "event_past": "Este evento ya ha finalizado",
      "event_deleted": "Este evento ha sido eliminado",
      "already_accepted": "Ya ha aceptado esta invitación",
      "already_declined": "Ha rechazado esta invitación",
      "latency_required": "Comprobación de ubicación requerida",
      "latency_description": "Para garantizar la mejor experiencia, necesitamos comprobar su conexión con nuestros servidores.",
      "run_latency_test": "Ejecutar prueba de conexión",
      "latency_running": "Comprobando la calidad de la conexión...",
      "error": {
        "title": "Error",
        "not_found": "No se pudo encontrar el evento",
        "not_participant": "No es participante de este evento"
      },
      "toast": {
        "success": {
          "title": "Respuesta registrada",
          "description": "Su confirmación se ha registrado correctamente"
        }
      }
    }
  }
}
